import { render, staticRenderFns } from "./_title_slug.vue?vue&type=template&id=65cdd218&scoped=true&"
import script from "./_title_slug.vue?vue&type=script&lang=js&"
export * from "./_title_slug.vue?vue&type=script&lang=js&"
import style0 from "./_title_slug.vue?vue&type=style&index=0&id=65cdd218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdd218",
  null
  
)

export default component.exports